import { Grid } from '@material-ui/core';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  fetchAllAsync,
  selectStatus,
  selectUnidadesNegocio,
  fetchByFilterAsync as fetchUnidadeNegocioByFilterAsync,
} from '../../features/unidade-negocio/unidadeNegocioSlice';
import QCXSimpleSelectManyPageTemplate from '../../templates/simple-select-many-page/QCXSimpleSelectManyPageTemplate';
import { isAlternativeLoadingStatus } from '../../utils/store/store-utils';

export default function QCXSelectManyUnidadeNegocioTable({ ...props }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { grupoUnidadeDeNegocio } = props;

  const unidadesNegocio = useSelector(selectUnidadesNegocio);
  const status = useSelector(selectStatus);

  const {
    title = t('com.muralis.qcx.unidadeNegocio.selecioneUnidadeNegocios'),
    filterProp = 'id',
    filterPropGetter = (data) => (
      data?.pessoa?.nomeResumido
    ),
    columns = [
      {
        field: 'id',
        headerName: t('com.muralis.qcx.codigo'),
        headerAlign: 'center',
        align: 'center',
        flex: 50,
      },
      {
        field: 'pessoa.nome',
        headerName: t('com.muralis.qcx.unidadeNegocio.label'),
        flex: 300,
        valueGetter: ({ row }) => (
          filterPropGetter(row)
        ),
      },
      {
        field: 'active', headerName: t('com.muralis.qcx.estado.ativo'), type: 'boolean', flex: 50,
      },
    ],
    selected,
    handleChange,
    isConsult,
    disableAutoFetch = false,
    ...restProps
  } = props;

  const isAlternativeLoading = useMemo(() => (
    isAlternativeLoadingStatus(status)
  ), [status]);
  useEffect(() => {
    if (grupoUnidadeDeNegocio?.length) {
      dispatch(
        fetchUnidadeNegocioByFilterAsync([{ name: 'grupo', value: grupoUnidadeDeNegocio[0].id.toString() }])
      );
    }
    if (!disableAutoFetch) {
      dispatch(fetchAllAsync());
    }
  }, []);

  const filterProps = [
    'id',
    'pessoa.nome',
  ];

  return (
    <>
      <Grid container direction="row" style={{ marginTop: '0.7rem' }}>
        <QCXSimpleSelectManyPageTemplate
          title={title}
          tableColumns={columns}
          tableData={unidadesNegocio}
          filterProp={filterProp}
          filterPropGetter={filterPropGetter}
          isLoading={isAlternativeLoading}
          isConsult={isConsult}
          handleSetSelected={handleChange}
          selected={selected}
          multipleFilter
          filterProps={filterProps}
          {...restProps}
        />
      </Grid>
    </>
  );
}
